export const GithubIntegrationService = {
  parseResourceUrl: (resourceUrl: string) => {
    const regex = /https:\/\/github.com\/([\w\-_]+\/[\w\-_]+)(?:\/)?(\w+)?(?:\/)?(\d+)?/
    const found = regex.exec(resourceUrl)
    const organization = found?.[1]
    const endpoint = found?.[2] || 'repo'
    const resourceId = found?.[3]

    return { organization, endpoint, resourceId }
  },
}
